import  * as InstrumentKPIConstants from './InstrumentKPIConstants';
import { produce } from "immer";
const assign = Object.assign || require('object.assign');


// The initial application state
const initialState = {};
// Takes care of changing the application state
export default function InstrumentKPIReducer(state = initialState, action) {
    switch (action.type) {
        case InstrumentKPIConstants.INSTRUMENT_KPI_DEVICE_STATE_ADD: {
            if (state[action.payload]) {
                return state;
            }

            const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    isReportIDFetching: false,
                    isReportIDFetched: false,
                    isWorkSpaceIDFetching: false,
                    isWorkSpaceIDFetched: false,
                    isFetchingFailed: false,
                    reportID: null,
                    workSpaceID: null
                }
            });
            return assign({}, state, newState);
        }
        case InstrumentKPIConstants.INSTRUMENT_KPI_DEVICE_STATE_REMOVE: {
            const newState = produce(state, (draft) => {
                if (draft[action.payload]) {
                    delete draft[action.payload];
                }
            });
            return assign({}, newState);
        }
        case  InstrumentKPIConstants.INSTRUMENT_KPI_REPORT_ID_API_SUCCESS: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    isReportIDFetching: false,
                    isReportIDFetched: true,
                    reportID: action.payload.newState
                }
            });
            return assign({}, state, newState);
        }
        case InstrumentKPIConstants.INSTRUMENT_KPI_REPORT_ID_API_FAILURE: {
            const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    isReportIDFetching: false,
                    isReportIDFetched: false,
                    isFetchingFailed: true,
                    reportID : null
                };
            });
            return assign({}, state, newState);
        }
        // Get group Name
        case  InstrumentKPIConstants.INSTRUMENT_KPI_GROUP_ID_API_SUCCESS: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    isWorkSpaceIDFetching: false,
                    isWorkSpaceIDFetched: true,
                    workSpaceID: action.payload.newState
                }
            });
            return assign({}, state, newState);
        }
        case InstrumentKPIConstants.INSTRUMENT_KPI_GROUP_ID_API_FAILURE: {
            const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    isWorkSpaceIDFetching: false,
                    isWorkSpaceIDFetched: false,
                    isFetchingFailed: true,
                    workSpaceID: null 
                };
            });
            return assign({}, state, newState);
        }
        default:
            return state;
    }
}